<template>
  <div class="columns not-found">
    <div class="column is-half-desktop is-full-tablet not-found__left">
      <img src="@/assets/images/not-found.svg" class="not-found__image" alt="找不到頁面">
    </div>
    <div class="column is-half-desktop is-full-tablet not-found__right">
      <h1 class="not-found__title">抱歉，找不到您要查看的頁面</h1>
      <p class="not-found__description">
        您可能輸入了不正確的地址，或頁面已經不存在，系統將在 {{ countdown }} 秒過後自動跳轉回首頁
      </p>
      <router-link to="/" class="button is-primary not-found__button">返回首頁</router-link>
    </div>
  </div>
</template>

<script>
import NotFound from './NotFound';

export default NotFound;
</script>

<style lang="scss" scoped>
@import './NotFound';
</style>
